<template>
    <v-card class="mx-10">
        <div class="text-right">
            <v-sheet class="my-3">
                <v-btn variant="elevated" color="cyan-darken-1" @click="newForm()"><v-icon
                        icon="mdi-pencil-plus"></v-icon>&nbsp;Nuevo</v-btn>
            </v-sheet>
        </div>

        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar registros" single-line hide-details
            color="blue-lighten-2"></v-text-field>

        <v-data-table :headers="headers" :items="datos" :search="search" :items-per-page-options="items_per_page_options"
            class="mt-10" :hover="true" :fixed-header="true" :height="500" :show-current-page="true" :loading="change_table"
            
             page-text="{0}-{1} de {2}">
            <template v-slot:top>
                <FormMenuRolePage :dialog_parent="dialog_form" :registro_parent="item_menuroles"
                    @closeDialogParent="closeDialogForm()" :formTitleParent="formTitle" @saveParent="save()"
                    :errors_validate_parent="errors_validate"
                    v-if="dialog_form">
                </FormMenuRolePage>
                <v-snackbar v-model="snackbar_registers_enabled" :timeout="2500" location="top" min-height="70"
                    :color="snackbar_color">
                    <p>{{ snackbar_registers_message }}</p>
                </v-snackbar>

                <v-dialog v-model="dialog_delete" max-width="500px" persistent>
                    <v-card>
                        <v-card-text class="text-center">
                            <v-icon class="as-scale" icon="mdi mdi-delete" size="100" color="red"></v-icon>
                        </v-card-text>
                        <p class="text-h4 text-center">
                            ¿Esta seguro de eliminar este registro?
                        </p>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" variant="elevated" @click="closeDialogDelete()">
                                <v-icon icon="mdi-file-cancel-outline"></v-icon>&nbsp;Cancelar</v-btn>
                            <v-btn color="cyan-darken-3" variant="elevated" @click="deleteConfirm()">
                                <v-icon icon="mdi-content-save-check-outline"></v-icon>&nbsp;OK
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                <v-icon @click="abrirDialogo(item.raw)" class="m-1" color="blue" icon="mdi-eye">
                </v-icon>
                <v-btn @click="editForm(item.raw)" class="m-1" color="cyan-darken-2" size="30" icon="mdi-pencil">
                </v-btn>
                <v-btn @click="deleteItem(item.raw)" color="red" class="m-1" size="30" icon="mdi-delete">
                </v-btn>
            </template>

            <template v-slot:no-data>
                <v-btn color="success" @click="search = ''"> Reseter </v-btn>
            </template>
        </v-data-table>
    </v-card>
    <v-dialog v-model="dialogoAbierto" max-width="500px">
        <v-card>
            <v-card-title> Contenido Individual </v-card-title>
            <v-card-text>
                <div><strong>ID: </strong> {{ id }}</div>
                <div><strong>MENU: </strong> {{ menunombre }}</div>
                <div><strong>ROL: </strong> {{ rolnombre }}</div>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="cerrarDialogo">Cerrar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
  
<script>
//import { VDataTable } from "vuetify/labs/VDataTable";
import { defineComponent } from "vue";
import FormMenuRolePage from "@/components/roles/FormMenuRolePage.vue";
import MenuRoles from "@/http/services/Menus";

export default defineComponent({
    components: {
        //VDataTable,
        FormMenuRolePage,
    },

    data() {
        const change_table = null;
        const obj_menuroles = new MenuRoles();
        const datos = [];
        const dialog_delete = false;
        const items_per_page_options = [
            { value: 10, title: "10" },
            { value: 25, title: "25" },
            { value: 50, title: "50" },
            { value: 100, title: "100" },
        ];
        const headers = [

            { title: "Menu", key: "menunombre" },
            { title: "Rol", key: "rolnombre" },

            { title: "Acciones", key: "actions", sortable: true },
        ];
        const default_item = {
            id: 0,
            menunombre: "",
            rolnombre: "",
            menu_id:"",
            role_id:"",

        };
        const item_menurol = default_item;
        const snackbar_registers_enabled = false;
        const snackbar_registers_message = "";
        const snackbar_color = "";
        const errors_validate = {};
        return {
            datos,
            obj_menuroles,
            change_table,
            dialog_form: false,
            dialog_delete,
            search: "",
            item_menuroles: "",
            headers,
            index_array: -1,
            item_menurol,
            default_item,
            items_per_page_options,
            snackbar_registers_enabled,
            snackbar_registers_message,
            snackbar_color,
            errors_validate,
            dialogoAbierto: false,
        };
    },

    computed: {
        formTitle() {
            return this.index_array === -1 ? "Nuevo registro" : "Editar registro";
        },
    },

    mounted() {
        this.registros();
    },

    methods: {
        abrirDialogo(item) {
            if (item) {
                this.id=item.id;
                this.menunombre = item.menunombre;
                this.rolnombre = item.rolnombre;
                this.dialogoAbierto = true;
            }
        },
        cerrarDialogo() {
            this.dialogoAbierto = false;
        },
        registros() {
            this.change_table = "cyan";
            setTimeout(async () => {
                const response = await this.obj_menuroles.menurolesget();
                console.log("Esta es la respuesta", response);
                this.datos = response.records;
                console.log("Esta es la respuesta de menus roles", this.datos);
                if (response.status) {
                    this.datos = response.records;
                } else {
                    console.error("Respuesta inválida o sin registros.");
                }
                this.change_table = null;
            }, 1000);
        },

        closeDialogForm() {
            this.clear();
            this.dialog_form = false;
            this.registros();
        },
        clear() {
            this.$nextTick(() => {
                this.item_menuroles = Object.assign({}, this.default_item);
                this.index_array = -1;
            });
            this.errors_validate = {};
        },
        newForm() {
            this.item_menuroles = Object.assign({}, this.default_item);
            this.dialog_form = true;
        },
        deleteItem(item) {
      this.index_array = this.datos.indexOf(item)
      //this.item_menuroles = item;
      this.item_menuroles = Object.assign({}, item)
      this.dialog_delete = true;
    },
    async deleteConfirm() {
      const obj_menuroles = new MenuRoles();
      const response = await obj_menuroles.eliminarmenuroles(this.item_menuroles.id);
      if (response.status) {
        this.snackbar_registers_enabled = true;
        this.snackbar_color = 'cyan-darken-3';
        this.snackbar_registers_message = response.message;
        this.datos.splice(this.index_array, 1)
      } else {
        this.snackbar_registers_enabled = true;
        this.snackbar_color = 'red';
        this.snackbar_registers_message = "Error interno del servidor";
      }

      this.closeDialogDelete()
    },
        closeDialogDelete() {
            this.dialog_delete = false
            this.clear();
        },

        editForm(item) {
            this.index_array = this.datos.indexOf(item)
            this.item_menuroles = Object.assign({}, item)
            this.dialog_form = true
        },
        
        /* async save() {
            const obj_menuroles = new MenuRoles(this.item_menuroles);

            // Extraer el ID de la menu y asignarlo a menu_id
            const menuId = this.item_menuroles.menu_id.split(' ')[0];
            this.item_menuroles.menu_id = menuId;
            console.log("Esta es la respuesta extraido de menu id", menuId);

            // Extraer el ID de la roles y asignarlo a role_id
            const roleId = this.item_menuroles.role_id.split(' ')[0];
            this.item_menuroles.role_id = roleId;
            console.log("Esta es la respuesta extraido del rol id", roleId);

            if (this.item_menuroles.id > 0) {
                Object.assign(this.datos[this.index_array], this.item_menuroles);
                const response = await obj_menuroles.modificarmenus(this.item_menuroles);
                if (response.status) {
                    this.snackbar_registers_enabled = true;
                    this.snackbar_color = "cyan-darken-3";
                    this.snackbar_registers_message = response.message;
                    this.closeDialogForm();
                } else {
                    this.snackbar_registers_enabled = true;
                    this.snackbar_color = "red";
                    if (response.validate_errors) {
                        this.errors_validate = response.message_errors;
                        this.snackbar_registers_message = response.message;
                    } else {
                        this.snackbar_registers_message = "Error interno en el servidor";
                    }
                }
            } else {
                const response = await obj_menuroles.registrarmenuroles(this.item_menuroles);
                if (response.status) {
                    this.snackbar_color = "cyan-darken-3";
                    this.snackbar_registers_enabled = true;
                    this.snackbar_registers_message = response.message;
                    this.closeDialogForm();
                } else {
                    this.snackbar_color = "red";
                    this.snackbar_registers_enabled = true;
                }
            }
        }, */
        async save() {
        const obj_menuroles = new MenuRoles(this.item_menuroles);
      const menuId = typeof this.item_menuroles.menu_id === 'string' ? this.item_menuroles.menu_id.split(' ')[0] : '';
      console.log('menu_id:', this.item_menuroles.menu_id);
      this.item_menuroles.menu_id = menuId;
      console.log("Esta es la respuesta extraido", menuId);

      // Extraer el ID de la pais y asignarlo a agencia_id
      const roleId = typeof this.item_menuroles.role_id === 'string' ? this.item_menuroles.role_id.split(' ')[0] : '';
      this.item_menuroles.role_id = roleId;
      console.log("Esta es la respuesta extraido", roleId);
      if (this.item_menuroles.id > 0) {
        Object.assign(this.datos[this.index_array], this.item_menuroles);
        const response = await obj_menuroles.modificarmenuroles(this.item_menuroles);
        if (response && response.status) {
          this.snackbar_registers_enabled = true;
          this.snackbar_color = "cyan-darken-3";
          this.snackbar_registers_message = response.message;
          this.closeDialogForm();
        } else {
          this.snackbar_registers_enabled = true;
          this.snackbar_color = "red";
          if (response.validate_errors) {
            this.errors_validate = response.message_errors;
            this.snackbar_registers_message = response.message;
          } else {
            this.snackbar_registers_message = "Error interno en el servidor";
          }
        }
      } else {
        const response = await obj_menuroles.registrarmenuroles(this.item_menuroles);
      console.log("Esta es la respuesta", response);
      if (response.status) {
        this.snackbar_color = "cyan-darken-3";
        this.snackbar_registers_enabled = true;
        this.snackbar_registers_message = response.message;
        //this.item_menuroles.id = response.record.id;
        this.datos.push(this.item_menuroles);
        this.closeDialogForm();
        this.registros();
      } else {
        this.snackbar_color = "red";
        this.snackbar_registers_enabled = true;
        this.closeDialogForm();
        this.registros();
        if (response.validate_errors) {
          this.snackbar_registers_message = response.message;
          this.errors_validate = response.message_errors;
        } else {
          this.snackbar_registers_message = "Error interno en el servidor";
        }
      }
      }
      
    },

    },
});
</script>
  